// services/AgroDashboard.js

import axios from 'axios'

const BASE = '/api/dashboard/agro'

const AgroDashboardService = {
    getDashboard: ({ year, site_id, nursery_id, specie_id, project_type }) =>
        axios
            .get(`${BASE}/nursery`, { params: { year, site_id, nursery_id, specie_id, project_type } })
            .then((res) => res.data.data),

    listNursery: (site_id) => axios.get(`${BASE}/listNursery`, { params: { site_id } }).then((res) => res.data.data),

    getSpecies: (nursery_id) => axios.get(`${BASE}/${nursery_id}/species`).then((res) => res.data.data),

    getPlantationDashboard: ({ year, customerId, plotId, projectType }) =>
        axios
            .get(`${BASE}/plantation`, { params: { year, customerId, plotId, projectType } })
            .then((res) => res.data.data),

    getNurseryCount: (region) =>
        axios.get(`${BASE}/nursery/count`, { params: { region } }).then((res) => res.data.data),

    getPlantationYearlyCumulative: () => axios.get(`${BASE}/plantation/yearly-cumulative`).then((res) => res.data.data),

    getPlotsCount: ({ village, year }) =>
        axios.get(`${BASE}/plots/count`, { params: { village, year } }).then((res) => res.data.data),

    getPlotsSurfaceCumulative: ({ village }) =>
        axios.get(`${BASE}/plots/surface-cumulative`, { params: { village } }).then((res) => res.data.data),

    getCustomersCumulative: (year) =>
        axios.get(`${BASE}/customers/cumulative`, { params: { year } }).then((res) => res.data.data),
    getOrderPipeline: ({ plantation_type, year, customer_id }) =>
        axios
            .get(`${BASE}/order-pipeline`, { params: { plantation_type, year, customer_id } })
            .then((res) => res.data.data),
    getOrderCustomers: () => axios.get(`${BASE}/order-customers`).then((res) => res.data.data),
    getPeasantsWithPlotsCount: ({ year, region, district, commune, fkt, village }) =>
        axios
            .get(`${BASE}/peasants-with-plots/count`, { params: { year, region, district, commune, fkt, village } })
            .then((res) => res.data.data)
}

export default AgroDashboardService
